import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=9a6920e6&scoped=true&"
import script from "./PackageDetails.vue?vue&type=script&lang=js&"
export * from "./PackageDetails.vue?vue&type=script&lang=js&"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=9a6920e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6920e6",
  null
  
)

export default component.exports